import React from 'react'
import { FaHome, FaNewspaper, FaUser, FaUsers } from 'react-icons/fa';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, Route, Routes } from 'react-router-dom';
import { TbReportAnalytics } from "react-icons/tb";
import { PiUserCircleLight } from "react-icons/pi";
import { CiLogout } from "react-icons/ci";
import { Box, TextField } from '@mui/material';
import { Button } from 'reactstrap';
import { IoNotificationsCircleOutline } from "react-icons/io5";
import { TbMessage } from "react-icons/tb";
import Dashboard from './Dashboard';
import AddNews from './AddNews';
import UsersList from './UsersList';
import NewsList from './NewsList';
import logo from '../../img/smartcard_logo.png'
import ContactUsList from './ContactUsList';



function Main() {
    return (
        <div>
            <div className='row0'>
                <div className='col-sm-20 left-mnu'>
                    <Sidebar backgroundColor='#3f51b5'>
                        <div className='bg-light border-right-1'>
                            {/* <PiUserCircleLight /> */}
                            <img src={logo} />
                            {/* <h3>Admin</h3> */}

                        </div>
                        <Menu>
                            <MenuItem icon={<FaHome />} component={<Link to="/dashboard" />}> Dashboard</MenuItem>
                            <SubMenu label="News" icon={<FaNewspaper />}>
                                <MenuItem component={<Link to="/dashboard/add-news" />}> Add News </MenuItem>
                                <MenuItem component={<Link to='/dashboard/news-list' />} > List news </MenuItem>
                            </SubMenu>

                            <MenuItem icon={<FaUsers />} component={<Link to="/dashboard/users-list" />}> User List</MenuItem>
                            <MenuItem icon={<FaUsers />} component={<Link to="/dashboard/contact-us-list" />}> Contact us data</MenuItem>
                            <MenuItem icon={<TbReportAnalytics />} component={<Link to="/e-commerce" />}> Report</MenuItem>
                            <MenuItem icon={<CiLogout />} component={<Link to="/e-commerce" />}> Logout</MenuItem>
                        </Menu>
                    </Sidebar>
                </div>
                <div className='col-sm-90 content-areas'>
                    <div className='navbar-menu'>
                        <IoNotificationsCircleOutline />
                        <TbMessage />
                    </div>
                    <div className='mrhgn'>
                        <Routes>
                            <Route path='/' element={<Dashboard />} ></Route>
                            <Route path='/add-news' element={<AddNews />} ></Route>
                            <Route path='/news-list' element={<NewsList />} ></Route>
                            <Route path='/users-list' element={<UsersList />} ></Route>
                            <Route path='/contact-us-list' element={<ContactUsList />} ></Route>
                        </Routes>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Main